'use client';
import { ButtonProps, SxProps } from '@mui/material';
import { WhiteButtonWrapper, WhiteButtonLabel } from './styles';

interface WhiteButtonProps extends ButtonProps {
    readonly label: string;
    readonly icon?: React.ReactNode;
    readonly isBig?: boolean;
    readonly themeColor?: string;
    readonly labelStyle?: SxProps;
    readonly fullWidth?: boolean;
}

const WhiteButton = (props: WhiteButtonProps) => {
    const { icon, label, isBig, labelStyle, fullWidth, ...buttonProps } = props;
    return (
        <WhiteButtonWrapper
            isBig={isBig}
            fullWidth={fullWidth}
            variant={'contained'}
            themeColor={props.themeColor}
            {...buttonProps}
        >
            {icon && icon}
            <WhiteButtonLabel hasIcon={!!icon} isDisabled={props.disabled} sx={labelStyle}>
                {label}
            </WhiteButtonLabel>
        </WhiteButtonWrapper>
    );
};

export { WhiteButton };
